import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    const shouldHidePrices = !hasCompleteProfile && !isPricesUnlocked;

    return {
        shouldHidePrices,
        hasCompleteProfile
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    const shouldHidePrices = !hasCompleteProfile && !isPricesUnlocked;

    return {
        shouldHidePrices,
        hasCompleteProfile
    };
};
